module.exports = __webpack_public_path__ + "img/Reward Stickers.ff33855a.svg";